import { handleAuthenticationError } from './authenticationHandler'
import { handlePhoneValidationError } from './phoneValidationHandler'
import { ExtensionErrorParams } from './types'

/**
 * Handles extension errors based on error codes
 * @param params - Object containing error code, callback, and router
 */
export const handleExtensionError = ({
  code,
  callback,
  router,
}: ExtensionErrorParams): void => {
  if (code === 'UNAUTHENTICATED') {
    handleAuthenticationError(callback)
    return
  }
  if (code === 'UNAUTHORIZED') {
    handleAuthenticationError(callback)
    return
  }

  if (code === 'ENFORCE_CUSTOMER_PHONE_VALIDATION_FAILED' && router) {
    handlePhoneValidationError(router)
    return
  }

  // Default callback for unhandled extension errors
  callback()
}
